import { render, staticRenderFns } from "./PasswordExpiredLink.vue?vue&type=template&id=be7ecc18&scoped=true&"
import script from "./PasswordExpiredLink.vue?vue&type=script&lang=js&"
export * from "./PasswordExpiredLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7ecc18",
  null
  
)

export default component.exports